// base
import { createAsyncThunk } from '@reduxjs/toolkit';

// api
import { excelApi } from '../apis/excel.api';

// action
import { actions } from '../actions/excel.action';

// models
import { ReqCreateBatchExcel, ResExcel, ResPostUserBatch } from '../models/excel.model';

// libraries
import qs from 'qs';

// utils
import { convertDataUrlToExcel } from 'utils';

/**
 *  엑셀 Batch Enroll
 */
export const createBatchExcel = createAsyncThunk<ResPostUserBatch, ReqCreateBatchExcel>(
  actions.EXCEL_ENROLL,
  async (data, { fulfillWithValue, rejectWithValue }) => {
    try {
      const formData = new FormData();

      formData.append('type', data.type);
      formData.append('writerId', data.writerId);

      if (data.file) {
        formData.append('file', convertDataUrlToExcel(data.file));
      }

      const response = await excelApi.postUserBatch(formData);

      return fulfillWithValue(response);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * 엑셀 템플릿 다운로드
 */
export const downLoadExcelTemplate = createAsyncThunk<ResExcel, void>(
  actions.EXCEL_DOWNLOAD_TEMPLATE,
  async (_, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await excelApi.fetchUserBatchTemplate();

      return fulfillWithValue(response);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * 엑셀 다운로드 리스트
 */
export const downLoadExcels = createAsyncThunk(
  actions.EXCEL_DOWNLOAD_LIST,
  async (data, { fulfillWithValue, rejectWithValue }) => {
    try {
      const query = qs.stringify(data);
      const response = await excelApi.fetchExcels(query);

      return fulfillWithValue(response);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
